import type { IPublicClientApplication } from '@azure/msal-browser';

let _msalInstance: IPublicClientApplication | null = null;

export function setMsalInstance(instance: IPublicClientApplication) {
  _msalInstance = instance;
}

export function getMsalInstance(): IPublicClientApplication | null {
  return _msalInstance;
}
